import { ReactNode, useEffect } from 'react'
import { useAppStore } from '../stores'
import { useWorkspaces } from '../hooks'

declare global {
  interface Window {
    Candu?: {
      init: (config: any) => void
    }
  }
}

type Props = {
  children: ReactNode
}

export const CanduProvider = ({ children }: Props) => {
  const currentUser = useAppStore((state) => state.currentUser)
  const { data: workspaces } = useWorkspaces()

  useEffect(() => {
    if (!window.Candu) {
      return
    }

    if (!currentUser || !workspaces) {
      return
    }

    window.Candu.init({
      clientToken: 'kOB41O20Dh',
      userId: currentUser.id,
      traits: {
        email: currentUser.email,
        createdAt: currentUser.createdAt,
        lastLoginAt: new Date().toISOString(),
        displayName: currentUser.displayName,
        emailVerified: currentUser.emailVerified,
      },
      groups: workspaces.map((workspace) => ({
        id: workspace.id,
        traits: {
          name: workspace.name,
          plan: workspace.plan,
          createdAt: workspace.createdAt,
          isOwner: workspace.ownerId === currentUser.id,
        },
      })),
    })
  }, [currentUser, workspaces])

  return <>{children}</>
}
